(() => {
    /***** 1. Original toast logic kept verbatim *****/
    window.upsellToastState = { isActive: false, originalFunction: null };
    function suppressCartToast () {
      if (window.skipToastSuppression || window.upsellToastState.isActive) return;
      window.upsellToastState.isActive = true;
      const notification = document.querySelector('cart-notification');
      if (notification && notification.renderContents) {
        window.upsellToastState.originalFunction = notification.renderContents;
        notification.renderContents = data => {
          console.log('[Upsell] Toast suppressed, storing data for later');
          window._upsellAddResp = data;
        };
      }
    }
    function restoreCartToast () {
      if (!window.upsellToastState.isActive) return;
      window.upsellToastState.isActive = false;
      const notification = document.querySelector('cart-notification');
      if (notification && window.upsellToastState.originalFunction) {
        notification.renderContents = window.upsellToastState.originalFunction;
        window.upsellToastState.originalFunction = null;
      }
    }
    window.restoreCartToast = restoreCartToast;   // still usable in popup close
  
    /***** 2. Intercept EVERY /cart/add(.js) fetch *****/
    const nativeFetch = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      const url = typeof input === 'string' ? input : input.url;
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        // Only suppress toast if we're going to show the popup
        if (!window.skipUpsellPopup) {
          suppressCartToast();                     // apply BEFORE network call
        }
  
        return nativeFetch(input, init)
          .then(res => {
            if (!res.ok) return res;             // error path - let theme handle
            return res.clone().json().then(data => {
              // ONLY trigger popup if not adding a booster
              if (!window.skipUpsellPopup) {
                window._upsellAddResp = data;      // stash for toast replay
                triggerPopup();                    // show upsell
              }
              // If skipUpsellPopup is true, let the normal toast show
  
              return res;
            });
          })
          .catch(err => {
            if (!window.skipUpsellPopup) {
              restoreCartToast();                  // clean up on failure
            }
            throw err;
          });
      }
      return nativeFetch(input, init);           // non-cart requests untouched
    };
  
    /***** 3. Backup listener for non-AJAX <form> submissions *****/
    document.addEventListener('submit', evt => {
      const form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (/\/cart\/add(\.js)?/.test(action)) {
        // Only suppress if we're going to show popup
        if (!window.skipUpsellPopup) {
          suppressCartToast();
        }
      }
    });
  
    /***** 4. Popup trigger *****/
    function triggerPopup () {
      if (typeof window.showUpsellPopup === 'function') {
        window.showUpsellPopup();
      } else {
        // In case the snippet hasn't executed yet, wait for a custom event
        document.addEventListener('UpsellPopupReady', () =>
          window.showUpsellPopup(), { once: true });
      }
    }
  })();
